import React from 'react';
import { ArrowLeft } from 'lucide-react';

function BackButton({ onClick }) {
  return (
    <button
      onClick={onClick}
      className="absolute bottom-6 left-6 z-20 flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-[#1e3a8a]/80 to-[#3b82f6]/80 rounded-full text-[#a3e4f6] hover:text-white transition-colors shadow-lg hover:shadow-[#3b82f6]/20 backdrop-blur-sm border border-[#3b82f6]/20"
      style={{ fontFamily: 'Futhark' }}
    >
      <ArrowLeft size={20} />
      <span>Back</span>
    </button>
  );
}

export default BackButton;
